/* TRYOVIA — Panier premium : upsell + code promo + mise en forme promo premium */
(function () {
  function routes() { return window.routes || {}; }

  /* ===== PROMO PREMIUM — enrichissement DOM du bloc remise appliquée ===== */
  /*
   * Shopify rend les remises panier sous cette forme brute :
   *   <li class="discounts__discount discounts__discount--end">
   *     [svg icon]
   *     RITUEL D'ÉTÉ · -30% · ÉDITION LIMITÉE (-35,99€)
   *   </li>
   * On va splitter le texte : partie gauche (label) | partie droite (montant en ())
   * et wrapper en deux spans avec les classes tv-promo-label et tv-promo-amount.
   */
  function enrichPromoDiscounts() {
    document.querySelectorAll('.discounts__discount--end').forEach(function (el) {
      if (el.querySelector('.tv-promo-label')) return; /* déjà enrichi */

      /* Extraire le texte brut (sans le svg) */
      var rawText = '';
      el.childNodes.forEach(function (node) {
        if (node.nodeType === 3) { /* TEXT_NODE */
          rawText += node.textContent;
        }
      });
      rawText = rawText.trim();
      if (!rawText) return;

      /* Chercher le montant entre parenthèses à la fin : ex "(-35,99€)" */
      var amountMatch = rawText.match(/\(([^)]+)\)\s*$/);
      var amountText = amountMatch ? amountMatch[0] : '';
      var labelText  = amountMatch
        ? rawText.slice(0, rawText.lastIndexOf(amountMatch[0])).trim()
        : rawText;

      /* Nettoyer le label : retirer tirets/points orphelins en fin */
      labelText = labelText.replace(/[\s\u00b7\-\.]+$/, '').trim();

      /* Vider l'élément et reconstruire */
      el.innerHTML = '';

      var labelSpan = document.createElement('span');
      labelSpan.className = 'tv-promo-label';
      labelSpan.textContent = labelText;

      el.appendChild(labelSpan);

      if (amountText) {
        var amountSpan = document.createElement('span');
        amountSpan.className = 'tv-promo-amount';
        /* Afficher le montant sans les parenthèses, avec un − */
        amountSpan.textContent = '−\u00a0' + amountText.replace(/[()]/g, '').trim();
        el.appendChild(amountSpan);
      }
    });
  }

  /* Observer les changements dans le tiroir (après renderContents) */
  function observeCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var obs = new MutationObserver(function () {
      enrichPromoDiscounts();
    });
    obs.observe(drawer, { childList: true, subtree: true });
    /* Passe initiale */
    enrichPromoDiscounts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCart);
  } else {
    observeCart();
  }

  /* ===== UPSELL ===== */
  window.tryoviaCartAdd = function (variantId, btn) {
    if (!variantId) return;
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    var prevLabel;
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      prevLabel = btn.innerHTML;
      btn.innerHTML = '\u2026';
    }
    fetch((routes().cart_add_url || '/cart/add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { throw new Error(data.description || 'add error'); }
        if (cartDrawer && data && data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tryovia-upsell', cartData: data });
        }
      })
      .catch(function (e) { console.error('tryoviaCartAdd', e); })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); if (prevLabel) btn.innerHTML = prevLabel; }
      });
  };

  /* ===== CODE PROMO ===== */
  window.tryoviaApplyDiscount = function (wrap) {
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var btn = wrap.querySelector('button');
    var code = ((input && input.value) || '').trim();
    if (!code) return;
    if (btn) btn.setAttribute('disabled', 'disabled');
    wrap.classList.add('tv-loading');
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', { headers: { 'Accept': 'text/html' } })
      .then(function () { return fetch((routes().cart_url || '/cart') + '?section_id=cart-drawer'); })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var html = new DOMParser().parseFromString(txt, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var target = document.querySelector(sel);
          var src = html.querySelector(sel);
          if (target && src) { target.replaceWith(src); }
        });
        enrichPromoDiscounts();
      })
      .catch(function (e) { console.error('tryoviaApplyDiscount', e); })
      .finally(function () {
        wrap.classList.remove('tv-loading');
        if (btn) btn.removeAttribute('disabled');
      });
  };

  /* Touche Entrée dans le champ code promo */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.matches && t.matches('.tv-discount input')) {
      e.preventDefault();
      window.tryoviaApplyDiscount(t.closest('.tv-discount'));
    }
  });

  /* ===== BUNDLE — override propre : remplir le tiroir AVANT de l'ouvrir =====
   * La version d'origine (dans la fiche ORA) ouvrait le tiroir vide puis le
   * re-rendait + re-ouvrait après 50 ms : au 1er ajout le header/footer ne se
   * posaient pas et le bouton paiement restait en version désactivée. On la
   * remplace ici par le flux propre (fetch -> renderContents qui ouvre lui-même).
   * Chargé en defer => s'exécute après le script de la fiche et l'écrase. */
  window.tryoviaBundleAdd = function (ids, btn) {
    ids = (ids || []).filter(function (x) { return x; });
    if (!ids.length) return;
    var cartDrawer = document.querySelector('cart-drawer');
    var r = routes();
    if (btn) { btn.disabled = true; btn.dataset.originalText = btn.dataset.originalText || btn.innerText; btn.innerText = 'Ajout\u2026'; btn.style.opacity = '0.7'; }
    var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    fetch((r.cart_add_url || '/cart/add'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) { throw new Error(data.description || 'add error'); }
        if (data && data.sections && data.sections['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          if (b) b.innerHTML = data.sections['cart-icon-bubble'];
        }
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          if (data && data.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tryovia-bundle', cartData: data });
        }
        if (btn) { btn.innerText = '\u2713 Ajout\u00e9'; btn.style.opacity = '1'; btn.style.background = '#2a7a2a'; btn.style.borderColor = '#2a7a2a'; setTimeout(function () { btn.disabled = false; btn.innerText = btn.dataset.originalText; btn.style.background = ''; btn.style.borderColor = ''; btn.style.opacity = ''; }, 2200); }
      })
      .catch(function (err) { console.error('tryoviaBundleAdd', err); if (btn) { btn.disabled = false; btn.innerText = btn.dataset.originalText || 'Ajouter le bundle'; btn.style.opacity = ''; } window.location.href = (r.cart_url) || '/cart'; });
  };

  /* ===== Filet de sécurité bouton paiement =====
   * Délégué sur document (survit aux renderContents). Garantit que le clic sur
   * « Procéder au paiement » soumet bien le panier vers le checkout, même si
   * l'association form= échoue dans un état de rendu partiel. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout') : null;
    if (!btn || btn.disabled) return;
    var form = document.getElementById('CartDrawer-Form');
    if (!form) return;
    e.preventDefault();
    if (!form.getAttribute('action')) { form.setAttribute('action', (routes().cart_url) || '/cart'); }
    if (!form.querySelector('input[name="checkout"]')) {
      var flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'checkout';
      flag.value = '';
      form.appendChild(flag);
    }
    HTMLFormElement.prototype.submit.call(form);
  }, true);
})();
